import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'

function Label(props) {
  const theme = useTheme()
  const { v, fw, bold, caption, color, style, children, ...restProps } = props

  let isMaterialColor = ['primary', 'secondary', 'error'].includes(color)

  let s = {
    fontWeight: fw || bold ? 'bold' : undefined,
    color: isMaterialColor ? undefined : (
      color === 'caption' || caption ? theme.palette.textColor.caption : color
    )
  }

  let materialProps = {
    variant: v,
    color: isMaterialColor ? color : undefined
  }

  return (
    <Typography component={'div'} style={{ ...s, ...style }} {...materialProps} {...restProps}>
      {children}
    </Typography>
  )
}

Label.propTypes = {
  v: PropTypes.oneOf([
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'subtitle1', 'subtitle2',
    'body1', 'body2',
    'caption',
    'button',
    'overline',
    'srOnly',
    'inherit',
  ]),
  bold: PropTypes.bool,
  caption: PropTypes.bool,
  ...Typography.props
}

Label.defaultProps = {
  bold: false,
  caption: false
}

export default Label